"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportInsightWidgetHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var general_1 = require("../../events/general");
var insight_1 = require("../../events/insight");
var executionResultsSelectors_1 = require("../../store/executionResults/executionResultsSelectors");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function performExport(executionResult, config) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var exporter, result;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    exporter = sdk_ui_1.createExportFunction(executionResult);
                    return [4 /*yield*/, exporter(config)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.uri];
            }
        });
    });
}
function validateIsExportable(ctx, cmd, ref) {
    var isExportable;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(executionResultsSelectors_1.selectIsExecutionResultReadyForExportByRef(ref))];
            case 1:
                isExportable = _a.sent();
                if (!isExportable) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "The widget with ref: " + sdk_model_1.serializeObjRef(ref) + " cannot be exported at the moment.");
                }
                return [2 /*return*/];
        }
    });
}
function validateSettingsAndPermissions(ctx, cmd) {
    var _a, config, ref, canExport;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, config = _a.config, ref = _a.ref;
                canExport = false;
                if (!(config.format === "csv")) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.select(executionResultsSelectors_1.selectIsExecutionResultExportableToCsvByRef(ref))];
            case 1:
                canExport = _b.sent();
                _b.label = 2;
            case 2:
                if (!(config.format === "xlsx")) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.select(executionResultsSelectors_1.selectIsExecutionResultExportableToXlsxByRef(ref))];
            case 3:
                canExport = _b.sent();
                _b.label = 4;
            case 4:
                if (!canExport) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "The widget with ref: " + sdk_model_1.serializeObjRef(ref) + " cannot be exported because the feature is disabled or the user does not have the necessary permissions.");
                }
                return [2 /*return*/];
        }
    });
}
function exportInsightWidgetHandler(ctx, cmd) {
    var _a, config, ref, executionEnvelope, resultUri, fullUri;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, config = _a.config, ref = _a.ref;
                return [4 /*yield*/, effects_1.put(insight_1.insightWidgetExportRequested(ctx, ref, config, cmd.correlationId))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.call(validateIsExportable, ctx, cmd, ref)];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects_1.call(validateSettingsAndPermissions, ctx, cmd)];
            case 3:
                _b.sent();
                return [4 /*yield*/, effects_1.select(executionResultsSelectors_1.selectExecutionResultByRef(ref))];
            case 4:
                executionEnvelope = _b.sent();
                // executionResult must be defined at this point
                ts_invariant_1.default(executionEnvelope === null || executionEnvelope === void 0 ? void 0 : executionEnvelope.executionResult);
                return [4 /*yield*/, effects_1.call(performExport, executionEnvelope.executionResult, config)];
            case 5:
                resultUri = _b.sent();
                fullUri = ctx.backend.config.hostname
                    ? new URL(resultUri, ctx.backend.config.hostname).href
                    : resultUri;
                return [2 /*return*/, insight_1.insightWidgetExportResolved(ctx, fullUri, cmd.correlationId)];
        }
    });
}
exports.exportInsightWidgetHandler = exportInsightWidgetHandler;
//# sourceMappingURL=exportInsightWidgetHandler.js.map